import { VIDEO_POPUP_SIZE } from './constants'

export const openVideoPopup = function(videoUrl, size = VIDEO_POPUP_SIZE.small, autoplay = true) {
  return {
    type: 'OPEN_VIDEO_POPUP',
    size,
    videoUrl,
    autoplay
  }
}

export const closeVideoPopup = function(){
  return { type: 'CLOSE_VIDEO_POPUP' }
}
